import React, { Dispatch, SetStateAction } from 'react';

import { AccidentTagsV2Details, EventDetails, ExtendedAccident } from '../../../../../backendsdk';
import useProfile from '../../../../../hooks/profile';
import { OE_ROLES } from '../../../Users/UsersComponent';
import TaggingComponent from '../../Tagging';

interface TaggingWrapperTabProps {
    details: ExtendedAccident;
    eventDetails?: EventDetails;
    handleSave: CallableFunction;
    accidentTags: AccidentTagsV2Details;
    setAccidentTags: Dispatch<SetStateAction<AccidentTagsV2Details>>;
    handleChange: CallableFunction;
    onBackTab: CallableFunction;
}

const TaggingWrapperTab: React.FC<TaggingWrapperTabProps> = (props: TaggingWrapperTabProps) => {
    const { profile } = useProfile();

    if (!OE_ROLES.includes(profile.role)) {
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (target: string, value: any) => {
        props.handleChange((oldDetails: ExtendedAccident) => {
            if (oldDetails && oldDetails[target as keyof ExtendedAccident] !== value) {
                return { ...oldDetails, [target]: value };
            }
            return oldDetails;
        });
    };

    const textOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleChange(event.target.name, event.target.value);
    };

    return (
        <TaggingComponent
            accidentTags={props.accidentTags}
            setAccidentTags={props.setAccidentTags}
            accidentId={props.details.accident_id}
            eventId={props.details.event || null}
            eventDetails={props.eventDetails}
            setEventId={textOnChange}
            onSave={() => props.handleSave()}
            onClose={() => props.onBackTab()}
            eventLevel={props.eventDetails?.level}
        />
    );
};

export default TaggingWrapperTab;
